import { render, staticRenderFns } from "./DetailsAddToCart.vue?vue&type=template&id=f61c1490&"
import script from "./DetailsAddToCart.vue?vue&type=script&lang=ts&"
export * from "./DetailsAddToCart.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsAddToCart.vue?vue&type=style&index=0&id=f61c1490&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports